module.exports = __webpack_public_path__ + "assets/img/low.a7eb743c.svg";